<template>
  <div
    class="email-notifications-tab-skeleton automations-scroll-panel"
    :class="`email-notifications-tab-skeleton--${variant}`"
    :data-testid="`email-notifications__skeleton--${variant}`"
  >
    <template v-if="variant === 'notifications'">
      <div class="email-notifications-tab-skeleton__toolbar">
        <v-skeleton-loader type="image" height="40" width="17.5rem" />
        <v-skeleton-loader type="image" height="40" width="6.5rem" />
        <v-skeleton-loader type="image" height="40" width="6.5rem" />
        <span class="email-notifications-tab-skeleton__spacer" />
        <v-skeleton-loader type="text" width="9rem" height="16" />
        <v-skeleton-loader type="button" height="32" width="8.5rem" />
      </div>
      <v-skeleton-loader
        type="table-heading, table-row-divider@10"
        class="email-notifications-tab-skeleton__table"
      />
      <v-skeleton-loader type="text" width="11rem" class="email-notifications-tab-skeleton__footer" />
    </template>

    <template v-else-if="variant === 'templates'">
      <div class="email-notifications-tab-skeleton__toolbar">
        <v-skeleton-loader type="image" height="40" width="17.5rem" />
        <span class="email-notifications-tab-skeleton__spacer" />
        <v-skeleton-loader type="text" width="9rem" height="16" />
        <v-skeleton-loader type="button" height="32" width="9rem" />
      </div>
      <v-skeleton-loader type="paragraph" width="85%" class="email-notifications-tab-skeleton__caption" />
      <div class="email-notifications-tab-skeleton__split">
        <section class="email-notifications-tab-skeleton__section">
          <v-skeleton-loader type="heading" width="8rem" class="mb-1" />
          <v-skeleton-loader type="text" width="20rem" class="mb-3" />
          <v-skeleton-loader type="table-heading, table-row-divider@4" />
        </section>
        <section class="email-notifications-tab-skeleton__section">
          <v-skeleton-loader type="heading" width="10rem" class="mb-1" />
          <v-skeleton-loader type="text" width="22rem" class="mb-3" />
          <v-skeleton-loader type="table-heading, table-row-divider@4" />
        </section>
      </div>
    </template>

    <template v-else-if="variant === 'cycle-table'">
      <v-skeleton-loader
        type="table-heading, table-row-divider@6"
        class="email-notifications-tab-skeleton__table email-notifications-tab-skeleton__table--cycle"
      />
    </template>

    <template v-else>
      <v-skeleton-loader
        type="table-heading, table-row-divider@12"
        class="email-notifications-tab-skeleton__table"
      />
      <v-skeleton-loader type="text" width="6rem" class="email-notifications-tab-skeleton__footer" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'EmailNotificationsTabSkeleton',
  props: {
    variant: {
      type: String,
      default: 'notifications',
      validator: (value) => ['notifications', 'templates', 'activity', 'cycle-table'].includes(value),
    },
  },
};
</script>

<style lang="scss" scoped>
@import './EmailNotificationsTabSkeleton.scss';
</style>
